import { render } from "./UserAppointmentsView.vue?vue&type=template&id=315998ff"
import script from "./UserAppointmentsView.vue?vue&type=script&lang=js"
export * from "./UserAppointmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__